import { createSelector } from "@reduxjs/toolkit"
import { ProfilesSelector } from "../../../store/selector"

export const BottomNavSelector = createSelector(
    [ProfilesSelector],
    (profiles) => {
        return profiles
    }
)